import { Platform } from "@linkfluence/models/platform";
import {
  CorporaSource,
  CorporaSourcePayload,
  CorporaTotalSourcesByPlatform,
} from "@radarly/models/corpora";

export interface CorporaRepo {
  getCorporaTotalSourcesByPlatform(
    project: number
  ): Promise<CorporaTotalSourcesByPlatform>;
  getCorporaPlatformSources(
    project: number,
    corpusId: number,
    platform: Platform,
    payload: CorporaSourcePayload
  ): Promise<CorporaSource[]>;
}

export const CorporaRepositoryUID = Symbol("Radarly/CorporaRepository");
